import * as ents from '@attain-apps/entities'
import { TypeChecker } from '@attain-apps/type-guards'

export interface Record {
  /** Ancestor entity names ordered from root to immediate parent */
  ancestors: readonly Record.Ancestor[]
  id: ents.core.dms.data.Record.Id
  name: string
}
export namespace Record {
  export interface Ancestor {
    key: string
    value: string
  }

  export const isAncestor = TypeChecker.Factory.object<Ancestor>({
    key: TypeChecker.isString,
    value: TypeChecker.isString,
  })

  export const isRecord = TypeChecker.Factory.object<Record>({
    ancestors: TypeChecker.Factory.list(isAncestor),
    id: ents.core.dms.data.Record.Id.isId,
    name: TypeChecker.isString,
  })

  /** Builds a breadcrumb label: "Campus A ▸ Building B ▸ Room 1" */
  export function toBreadcrumb(record: Record): string {
    const parts = record.ancestors.map(a => a.value)
    parts.push(record.name)
    return parts.join(' ▸ ')
  }
}
